import { useProfile } from '@/store/profile'

export const useIsReturningSelfEmployedCustomer = () => {
    const { profile } = useProfile()
    const { isReturningSelfAssessmentCustomer, selfAssessments } = profile

    return isReturningSelfAssessmentCustomer && !!selfAssessments.find(({ hasSelfEmployment }) => hasSelfEmployment)
}
